import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { env } from '@/config/env';
import { useAuthStore } from '@/app/store/authStore';
import { notificationKeys } from '@/features/notifications/notifications.keys';
import { useToastStore } from '@/app/store/notificationStore';

// Live-updates the notification bell over WebSocket instead of polling.
// On receipt it just invalidates the React Query cache — React Query
// stays the single source of truth for notification data, this hook
// only tells it "something changed, go refetch."
export function useWebSocketNotifications() {
  const queryClient = useQueryClient();
  const accessToken = useAuthStore((s) => s.accessToken);
  const pushToast = useToastStore((s) => s.pushToast);
  const socketRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (!accessToken || !env.wsUrl) return;

    const socket = new WebSocket(`${env.wsUrl}?token=${accessToken}`);
    socketRef.current = socket;

    socket.onmessage = (event) => {
      const payload = JSON.parse(event.data) as { type: string; title: string };
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      if (payload.type === 'approval_request') {
        pushToast({ variant: 'info', title: payload.title });
      }
    };

    return () => socket.close();
  }, [accessToken, queryClient, pushToast]);
}
